export default "__VITE_ASSET__C3ZCxV15__"